import { Route } from "@angular/router";
import { CadastrarPage } from "./cadastrar.page";

export const CadastrarRouter: Route[] = [
  { path: 'cadastrar', component: CadastrarPage }
];